import React from 'react';
import classNames from 'classnames';
import TabContent from '../TabContent';
import CheckoutFormHOC from '../../shared/CheckoutFormHOC';
import { BASIC_PACKAGE_ID } from '../../../utils/packagesUtils/constants';

import './style.scss';

const singleClasses = classNames('packages-tabs', 'single');

const SinglePackage = () => (
    <div className={singleClasses}>
        <CheckoutFormHOC selectedPackageId={BASIC_PACKAGE_ID} source="Top Right">
            <TabContent id={BASIC_PACKAGE_ID} showCompareAnchor={false}/>
        </CheckoutFormHOC>
    </div>
);

export default SinglePackage;
